export default class GiftAlertLayer {
  constructor() {
    this.welContainer = $('#_layerContainer');
    this.sWrapper = '_giftAlertLayer';
    this.expirationDate = 0;
    this.initTpl();
    this.cacheElement();
    this.setEvent();
  }

  cacheElement() {
    this.welGiftAlertContainer = $(`#${this.sWrapper}`);
  }

  setEvent() {
    this.welContainer.on('click', '[data-role=ok]', e => {
      e.preventDefault();
      TMON.oApp.oViews.closeLayer();
      TMON.oApp.setStorage('validateBuyGift', true);
    });
  }

  initTpl = () => {
    const sHtml = `<section id="${this.sWrapper}" class="popup popup_layer ${TMON.oApp.sPlatform === 'PW' ? 'popup_phishing' : 'popup_ticket_date'}" data-layerId="GiftAlertLayer"></section>`;
    this.welContainer.append(sHtml);
  };

  render = () => {
    const msg = !this.expirationDateCheck(
      TMON.oApp.htStorage.innerCartItems.aList
    )
      ? '옵션별 기간이 상이하며,'
      : `해당 상품의 유효기간은 구매일로부터 ${this.expirationDate}일 이며,`;
    const sHtml = `<header class="popup_header">
                <h3 class="popup_header_title">구매 전 꼭 확인해 주세요.</h3>
                <button type="button" class="popup_header_close" aria-label="팝업닫기" data-role="close">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                      <path fill="#30343B" fill-rule="evenodd" d="M0 0h.87v.87H0V0zm.87.87h.87v.87H.87V.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87H20V20h-.87v-.87zM20 0v.87h-.87V0H20zm-.87.87v.87h-.87V.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-1.739 1.739v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869H1.74v-.87h.87zm-.869.869v.87H.87v-.87h.87zm-.87.87V20H0v-.87h.87z"></path>
                  </svg>
                </button>
            </header>
            <div class="popup_contents">
                <!-- [D] 콘텐츠 -->
                <article class="popup_inner">
                  ${TMON.oApp.sPlatform === 'PW' ? `
                  <dl class="popup_definition_area">
                      <dt>
                          <strong class="blind"></strong>
                      </dt>
                      <dd>
                          <p class="popup_definition_desc">
                            <span class="text_color1">${msg}</span> <br>상대방이 선물 수락 후 사용이 가능합니다.
                          </p>
                          <p class="popup_definition_desc">
                          선물 수락은 최대 7일간 가능하며,</br>유효기간이 짧은 상품의 경우<br>선물 수락 전 자동 취소될수 있습니다.<br>선물하기를 진행하시겠습니까?
                          </p>
                      </dd>
                  </dl>
                  ` : `
                  <p>
                      <strong>${msg}</strong> <br>상대방이 선물 수락 후 사용이 가능합니다.
                  </p>
                  <p>
                      선물 수락은 최대 7일간 가능하며,</br>유효기간이 짧은 상품의 경우<br>선물 수락 전 자동 취소될수 있습니다.<br>선물하기를 진행하시겠습니까?
                  </p>
                  `}
                </article>
                <!-- [D] 버튼 -->
                <div class="popup_buttons">
                    <button type="button" class="popup_button type01 btn_confirm" data-role="ok">
                    확인
                    </button>
                </div>
            </div>`;

    this.welGiftAlertContainer.html(sHtml);
  };

  // 선택한 옵션이 1개 인가
  hasOneOption = list => list.length === 1;

  // 구매일로 부터 유효기간 차이 날짜 계산
  getExpirationDate = () => {
    // 일반딜일 경우 로직 구성 - (티켓종료날짜 - 현재날짜)
    // parameter - time = TMON.oApp.htStorage.innerCartItems.aList[0].ticketEndDate
    // const ticketExpireDay =
    //   TMON.oApp.htStorage.innerCartItems.aList[0].ticketExpireDay;
    // const ticketEndDay = Math.ceil(
    //   (new Date(time.replace(' ', 'T')) - new Date()) / (24 * 60 * 60 * 1000)
    // );
    //
    // return ticketExpireDay > ticketEndDay ? ticketEndDay : ticketExpireDay;
    return TMON.oApp.htStorage.innerCartItems.aList[0].ticketExpireDay;
  };

  // 조건 검증
  expirationDateCheck = list => {
    return (
      this.hasOneOption(list) &&
      Object.prototype.hasOwnProperty.call(list[0], 'ticketExpireDay')
    );
  };

  open = () => {
    this.expirationDate = this.expirationDateCheck(
      TMON.oApp.htStorage.innerCartItems.aList
    )
      ? this.getExpirationDate()
      : 0;
    this.render();
    if (TMON.oApp.sPlatform === 'PW') {
      TMON.oApp.oUtil.handleOpenLayer({
        welTargetLayer: $(`#${this.sWrapper}`),
        bSetHash: true,
        bUseHistorybackOnClose: true,
        bShowDimmed: true,
      });
    } else {
      TMON.oApp.oUtil.handleOpenLayer({
        welTargetLayer: $(`#${this.sWrapper}`),
      });
    }
  };
}
